import { createCmsProviderAdapter } from '@eneco/cms-sanity';
import { createSitecoreAdapter } from '@eneco/cms-sitecore';
import env from '@eneco/common/env';

import { sanitySite } from './config';

let instance: ReturnType<typeof createSitecoreAdapter> | undefined;

export const getCmsAdapter = () => {
  if (!instance) {
    const layoutServiceUrl = `${env('SITECORE_API_HOST')}${env('SITECORE_LAYOUT_SERVICE_ROUTE')}`;
    const apiKey = env('SITECORE_API_KEY');
    const site = env('SITECORE_API_SITE');
    instance = createSitecoreAdapter({ layoutServiceUrl, apiKey, site });
  }
  return instance;
};

// gb-eneco-main has opted into serving the `?_cms=` override on acceptance/production,
// not just development/local (see `allowSharedEnvironment` in `is-sanity-enabled.ts`).
// Sitecore still serves every unforced request; this only widens where the override works.
export const { getSanityAdapter, selectCmsAdapter } = createCmsProviderAdapter(getCmsAdapter, {
  site: sanitySite,
  allowSharedEnvironment: true,
});
